import { Button, FaIcons } from '@innovationnorway/component-library';
import React, { useEffect } from 'react';
import CreateLinkToOpportunityForm from 'src/features/one-way-in/components/create-link-form/CreateLinkToOpportunityForm';
import CustomerJourney from '../components/common-questions/OWI/CustomerJourney';

const GraphicalMaterials = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="full-width-layout stack">
      <h1>Grafisk materiale for Én vei inn</h1>
      <h2>Lag egen inngang fra deres nettside til Én vei inn</h2>
      <p>
        Vi har laget grafisk materiell som dere kan bruke på egne nettsider. Når kunder bruker lenken kommer
        henvendelsen med en gang inn i Flerbedriftsportalen. Kunden får automatisk en kort bekreftelse.
      </p>
      <h3>Fremgangsmåte</h3>
      <ol className="stack margin-bottom--6">
        <li>
          <p>Last ned det grafiske materialet og les den vedlagte veiledningen for implementasjon.</p>
          <Button
            iconName={FaIcons.FileDownloadLight}
            className="display--inline-block"
            href="EnVeiInnMateriale.zip"
          >
            Last ned materiale
          </Button>
        </li>
        <li>
          <p>Kopiér lenken til Én vei inn-skjemaet.</p>

          <CreateLinkToOpportunityForm />
        </li>
        <li>
          <p>Bruk den kopierte lenken til å koble nettsiden deres til Én vei inn-skjemaet.</p>
        </li>
      </ol>
      <CustomerJourney />
    </main>
  );
};

export default GraphicalMaterials;
